import { Textarea } from '@chakra-ui/react';
import React from 'react';
import './CustomTextArea.scss';
import { Controller } from 'react-hook-form';

import CustomDescriptionText from '@/common/CustomDescriptionText/CustomDescriptionText';
import { CustomFormControl } from '@/common/CustomFormControl/CustomFormControl';
import CustomFormFieldLabel from '@/common/CustomFormFieldLabel/CustomFormFieldLabel';
import { sanitizeClientInput } from '@/utils/sanitizeClientInput';

interface CustomTextAreaProps {
  name: string;
  label: string;
  placeholder: string;
  description?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  showFormValueOnly?: boolean;
  characterLimit?: number;
  size?: 'sm' | 'md' | 'lg';
}

const CustomTextArea = ({
  name,
  label,
  placeholder,
  description,
  isRequired = false,
  isDisabled = false,
  isReadOnly = false,
  showFormValueOnly = false,
  characterLimit = 280,
  size = 'md',
}: CustomTextAreaProps) => {
  return (
    <CustomFormControl
      componentName={'Custom Textarea'}
      name={name}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
      showFormValueOnly={showFormValueOnly}
    >
      <CustomFormFieldLabel
        label={label}
        size={size}
        isRequired={isRequired}
        isDisabled={isDisabled}
      />

      {description && <CustomDescriptionText description={description} />}

      <Controller
        name={name}
        defaultValue={''}
        render={({ field }) => {
          return (
            <Textarea
              {...field}
              onChange={e => {
                const clean = sanitizeClientInput(e.target.value);
                field.onChange(clean);
              }}
              className={'custom-textarea'}
              placeholder={placeholder}
              maxLength={characterLimit}
            />
          );
        }}
      />
    </CustomFormControl>
  );
};

export default CustomTextArea;
